import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import ArticleTemplate from "../pages/article/ArticleTemplate";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/what-is-oopbuy-spreadsheet",
    element: <ArticlePage />,
  },
  {
    path: "/article/:slug",
    element: <ArticleTemplate />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;